// extracted by mini-css-extract-plugin
export default {"container":"Ps-z","heading":"Qs-z","text":"Rs-z","info":"Ss-z","link":"Ts-z","fullMaxWidth":"Us-z"};